import { Flex } from "antd";
import { useTranslation } from "react-i18next";

import BaseModal from "@/components_v2/Modal/BaseModal";
import BaseButton from "@/components_v2/Button/BaseButton";
import EvidenceTable from "@/domains/evidence/components/EvidenceTable";
import { EvidenceNotificationModalProps } from "@/features/survey-views/form/types";
import { BUTTON_VARIANTS } from "@/components_v2/Button/constants";

const EvidenceNotificationModal = ({
  open,
  setOpen,
  evidenceIds,
  handleConfirm,
}: EvidenceNotificationModalProps) => {
  const { t } = useTranslation();

  return (
    <BaseModal
      title={t("surveyViews.labels.confirmUsageOfEvidence")}
      open={open}
      width={900}
      onCancel={() => setOpen(false)}
      footer={
        <Flex wrap justify="space-between" align="center" gap={"small"}>
          <BaseButton
            variant={BUTTON_VARIANTS.TERTIARY}
            key="cancel"
            onClick={() => setOpen(false)}
          >
            {t("buttons.cancel")}
          </BaseButton>

          <BaseButton
            variant={BUTTON_VARIANTS.PRIMARY}
            key="confirm"
            onClick={handleConfirm}
          >
            {t("buttons.confirm")}
          </BaseButton>
        </Flex>
      }
    >
      <p>{t("surveyViews.labels.confirmUsageOfEvidenceDescription")}</p>
      <EvidenceTable
        columnNames={["title", "type", "createdBy", "sharingRights"]}
        defaultFilters={{
          ids: evidenceIds,
        }}
        pagination={{
          defaultPageSize: 5,
        }}
      />
    </BaseModal>
  );
};

export default EvidenceNotificationModal;
